import type { ConfirmRecapAction } from "../types/action";
import type { HorrorRaceState } from "../types/game-state";

export function applyConfirmRecap(
  state: HorrorRaceState,
  action: ConfirmRecapAction,
): HorrorRaceState {
  const updatedPlayers = state.players.map((player) => {
    if (player.id !== action.playerId) {
      return player;
    }
    return { ...player, hasConfirmedRecap: true };
  });

  return {
    ...state,
    players: updatedPlayers,
  };
}
